import React from 'react'
import styles from './Index.module.css';

const Loader = ({ bgColor = "white" }) => {
    return (
        <div style={{ height: "100%", width: "100%", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: bgColor }}>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <div className={styles.loader}></div>
                <div style={{ fontSize: 20 }}>Loading</div>
            </div>
        </div>

    )
}

export default Loader